import moment from "moment";

export function getDefaultDOB() {
    let maxDateCal = moment().subtract('years', 13).add('days', 1);

    let maxDate = maxDateCal.format('YYYY-MM-DD');
    return maxDate;
}